import React, { useEffect, useRef, useState } from 'react';
import styles from './CallToAction.module.css';

const CallToAction: React.FC = () => {
  const backgroundRef = useRef<HTMLDivElement>(null);
  const [usePrimary, setUsePrimary] = useState(false);

  useEffect(() => {
    if (
      backgroundRef.current &&
      getComputedStyle(backgroundRef.current).getPropertyValue('--rf-primary')
    ) {
      setUsePrimary(true);
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <div
        ref={backgroundRef}
        className={`${styles.diamond} ${usePrimary ? styles.diamondPrimary : styles.diamondFallback}`}
      />
      <div className={styles.content}>
        {/* TouchIcon SVG */}
        <svg
          viewBox="0 0 48 67"
          xmlns="http://www.w3.org/2000/svg"
          stroke="currentColor"
          fill="currentColor"
          className={styles.icon}
        >
          <path
            d="m41 24c-1.7 0-3.2 0.65-4.4 1.7-1.2-1.1-2.7-1.7-4.4-1.7-1.7 0-3.2 0.65-4.4 1.7-0.48-0.44-1-0.8-1.6-1.1 2.1-2.6 3.4-6 3.4-9.5 2.8e-4 -8.3-6.7-15-15-15-8.3 0-15 6.7-15 15 0 5.8 3.3 11 8.4 13v18c0 11 8.9 20 20 20 11 0 20-8.9 20-20v-16c0-3.6-2.9-6.6-6.6-6.6zm-37-8.8c0-5.9 4.8-11 11-11 5.9 0 11 4.8 11 11 0 3.4-1.6 6.5-4.1 8.5v-8.5c0-3.6-2.9-6.6-6.6-6.6-3.6 0-6.6 2.9-6.6 6.6v8.5c-2.6-2-4.1-5.1-4.1-8.5zm39 32c0 8.5-6.9 15-15 15-8.5 0-15-6.9-15-15v-20c4e-3 -0.072 4e-3 -0.14 0-0.22v-12c0-1.2 1-2.3 2.3-2.3 1.2 0 2.3 1 2.3 2.3v20c0 1.2 0.96 2.1 2.1 2.1 1.2 0 2.1-0.96 2.1-2.1v-4.7c0-1.2 1-2.3 2.3-2.3s2.3 1 2.3 2.3v4.7c0 1.2 0.96 2.1 2.1 2.1 1.2 0 2.1-0.96 2.1-2.1v-4.7c0-1.2 1-2.3 2.3-2.3 1.2 0 2.3 1 2.3 2.3v4.7c0 1.2 0.96 2.1 2.1 2.1s2.1-0.96 2.1-2.1v-4.7c0-1.2 1-2.3 2.3-2.3 1.2 0 2.3 1 2.3 2.3v16z"
            strokeWidth=".29"
          />
        </svg>
        <p className={styles.label}>Touchez l&apos;écran pour commencer</p>
      </div>
    </div>
  );
};

export default CallToAction;
